import React from "react";
import PipelineFunnel from "./PipelineFunnel";
import CycleTimeTable from "./CycleTimeTable";
import AlertsPanel from "./AlertsPanel";
import PortfolioPnlPanel from "./PortfolioPnlPanel";

const LenderPerformanceDashboard = ({ dashboardData, pnlLoading, pnlError, onAlertSelect, isCaseLoading }) => {
  const dashboard = dashboardData;

  return (
    <div className="relative dark:bg-slate-950 bg-slate-50 dark:text-slate-100 text-slate-900 font-sans overflow-hidden animate-fade-in">
      <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-yellow-500/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-20 h-72 w-72 rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-slate-500 font-semibold">Performance Overview</p>
            <h1 className="text-3xl font-semibold dark:text-white text-slate-900 mt-2">Executive Dashboard</h1>
          </div>
          <div className="flex items-center gap-3">
            <span className="px-3 py-1 rounded-full border dark:border-slate-800 border-slate-200 dark:bg-slate-900/70 bg-white shadow-sm text-xs dark:text-slate-300 text-slate-600">
              Updated moments ago
            </span>
            <span className="px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-300 text-xs font-semibold">
              Live
            </span>
          </div>
        </div>
        <div className="space-y-6 mt-8">
          <section className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="md:col-span-2">
              <PipelineFunnel data={dashboard.pipeline} />
            </div>
            <div className="md:col-span-2">
              <PortfolioPnlPanel data={dashboard.pnlOverview} loading={pnlLoading} error={pnlError} />
            </div>
          </section>
          {/* <CycleTimeTable data={dashboard.cycleTimes} /> */}
          <section>
            <AlertsPanel alerts={dashboard.alerts} onAlertSelect={onAlertSelect} isLoading={isCaseLoading} />
          </section>
        </div>
      </div>
    </div>
  );
};

export default LenderPerformanceDashboard;
